package com.example.event_management_system.ui.screens.location

import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.example.event_management_system.data.models.Location
import com.example.event_management_system.data.models.Section
import com.example.event_management_system.data.models.UserRole
import com.example.event_management_system.data.repository.IAuthRepository
import com.example.event_management_system.data.repository.ILocationRepository
import com.example.event_management_system.data.repository.ISectionRepository
import com.example.event_management_system.data.repository.IUserRepository
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class LocationPickerState(
    val locations: List<Location> = emptyList(),
    val sectionsMap: Map<String, List<Section>> = emptyMap(),
    val isLoading: Boolean = true,
    val error: String? = null
)

class LocationPickerScreenModel(
    private val authRepository: IAuthRepository,
    private val userRepository: IUserRepository,
    private val locationRepository: ILocationRepository,
    private val sectionRepository: ISectionRepository
) : ScreenModel {

    private val sectionJobs = mutableMapOf<String, Job>()

    private val _state = MutableStateFlow(LocationPickerState())
    val state: StateFlow<LocationPickerState> = _state.asStateFlow()

    init {
        loadLocations()
    }

    private fun loadLocations() {
        screenModelScope.launch {
            _state.update { it.copy(isLoading = true) }
            val userId = authRepository.getCurrentUserId() ?: run {
                _state.update { it.copy(isLoading = false, error = "Not authenticated") }
                return@launch
            }
            val user = userRepository.getUser(userId) ?: run {
                _state.update { it.copy(isLoading = false, error = "User not found") }
                return@launch
            }
            val flow = if (user.role == UserRole.OWNER) {
                locationRepository.getAllLocationsFlow()
            } else {
                locationRepository.getLocationsByIdsFlow(user.locationIds)
            }
            try {
                flow.collect { locations ->
                    _state.update { it.copy(locations = locations, isLoading = false) }
                    locations.forEach { location ->
                        if (location.id !in sectionJobs) {
                            sectionJobs[location.id] = launch {
                                sectionRepository.getSectionsByLocationFlow(location.id).collect { sections ->
                                    _state.update { s -> s.copy(sectionsMap = s.sectionsMap + (location.id to sections)) }
                                }
                            }
                        }
                    }
                }
            } catch (e: Throwable) {
                _state.update { it.copy(isLoading = false, error = e.message ?: "Failed to load locations") }
            }
        }
    }

}
